<template>
    <div class="question-wrapper">
        <media-files v-if="item.files.length > 0" :files="item.files" />

        <p class="question">
            {{ item.title }}
        </p>

        <span class="text-subtitle-1">Установите соответствие</span>

        <div v-if="!mobile" class="answer-wrapper" ref="answerWrapper">
            <div
                v-for="(it, key) in item.terms"
                :key="'B'+key"
                class="answer"
                :class="{
                    'successAnswer': it.correct,
                    'errorAnswer': it.correct === false,
                    'border-top-left-radius-7': key === 0,
                    'border-bottom-left-radius-7': key === (item.terms.length - 1),
                }"
            >
                <v-row>
                    <v-col cols="12" sm="5" md="4">
                        {{ it.title }}
                    </v-col>
                    <v-col cols="12" sm="7" md="8">
                        <v-select
                            outlined
                            dense
                            :clearable="!viewBtnNext"
                            hide-details
                            item-text="title"
                            item-value="id"
                            :readonly="viewBtnNext"
                            return-object
                            v-model="it.selected"
                            @focus="selectTerms(item, it)"
                            @change="changeSelected"
                            :items="it.list"
                            label=""
                        >
                            <template v-slot:selection="{ item }">
                                <span :class="{'successText': it.correct}">{{item.title}}</span>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div v-else class="answer-wrapper" ref="answerWrapper">
            <div
                v-for="index in item.terms.length" 
                :key="`term_${index - 1}`"
                class="answer"
                :class="{
                    'successAnswer': item.terms[index - 1].correct,
                    'errorAnswer': item.terms[index - 1].correct === false,
                    'border-top-left-radius-7': index === 1,
                    'border-bottom-left-radius-7': index === item.terms.length,
                }"
            >
                <v-row>
                    <v-col cols="12" sm="5" md="4" class="col-term">
                        {{ item.terms[index - 1].title }}
                    </v-col>
                    <v-col cols="12" sm="7" md="8">
                        <draggable class="list-group" :list="answerLists[index - 1]" group="answers" @change="dragAnswer">
                            <div v-for="answer in answerLists[index - 1]" :key="answer.id" class="list-group-item" :class="{'successText': item.terms[index - 1].correct}">
                                {{ answer.title }}
                            </div>
                        </draggable>
                    </v-col>
                </v-row>
            </div>
            
        </div>

        <v-expand-transition>
            <div
                v-if="flag"
                class="block-text-information text-left subtitle-1 font-weight-medium mt-2"
                :class="{
                    'error-text': flagError,
                    'success-text': flagSuccess,
                }"
            >
                {{ text }}
            </div>
        </v-expand-transition>

        <v-expand-transition>
            <div class="btn-block mb-2" v-if="viewBtnAll">
                <v-btn :disabled="viewBtnNext" @click="checkQusest(item)" width="100%" color="blue darken-2" :dark="!viewBtnNext" elevation="2">Проверить результат</v-btn>

                <v-expand-transition>
                    <v-btn class="mt-4" v-if="viewBtnNext && stepModal !== 10" @click="nextQuestion()" width="100%" :color="flagSuccess ? 'success' : '#ed4040'" dark elevation="2">Дальше</v-btn>
                    
                    <v-btn class="mt-4" v-if="viewBtnNext && stepModal === 10" @click="$emit('getEstimation')" width="100%" color="primary" dark elevation="2">Получить оценку</v-btn>
                </v-expand-transition>
            </div>
        </v-expand-transition>
    </div>
</template>

<script>
import party from 'party-js'
import mediaFiles from '../../../../components/TaskMediaFiles.vue'
import draggable from "vuedraggable";
import { mapActions } from 'vuex'

export default {
    components: { mediaFiles, draggable },
    props: {
        item: { type: Object, required: true },
        apiUrl: { type: String, required: true },
        stepModal: { type: Number, required: true },
    },
    data: () => ({
        viewBtnAll: false,
        viewBtnNext: false,
        flag: false,
        flagError: false,
        flagSuccess: false,
        text: '',
        list: [],
        listFreezy: [],
        selected: [],
        mobile: false,
        answerLists: []
    }),
    methods: {
        ...mapActions({
            randomGenerate: 'tests/randomGenerate'
        }),
        nextQuestion() {
            this.$emit('nextStep')
        },
        selectTerms(item, it) {
            this.selected = [];

            for (let i = 0; i < item.terms.length; i++) {
                // возвращаем полный список в поле
                item.terms[i].list = item.terms[i].listFreeze;

                // Собираем список выбранных результатов из других полей
                if(item.terms[i].id !== it.id) {
                    this.selected.push(item.terms[i].selected)
                }

                this.$nextTick(() => {
                    // если это поле на которое нажали, то
                    if(it.id === item.terms[i].id) {
                        // если в списке есть выбранный результат
                        if(this.selected.length > 0) {
                            // фильтруем
                            const s = new Set(this.selected.map(e => JSON.stringify(e)));
                            item.terms[i].list = item.terms[i].list.filter(e => !s.has(JSON.stringify(e)));
                        }
                    }
                })
            }
        },
        changeSelected(e) {
            if(e) {
                this.viewBtnAll = true;
            } else {
                this.viewBtnAll = false;
            }
        },
        dragAnswer: function(evt) {
            if (!Object.hasOwn(evt, 'removed')) {
                return;
            }

            let fromList = null;
            let toList = null;

            for (let i = 0; i < this.answerLists.length; i++) {
                if (this.answerLists[i].length === 2) {
                    toList = this.answerLists[i];
                }

                if (this.answerLists[i].length === 0) {
                    fromList = this.answerLists[i];
                }
            }

            let prevItemIndex = toList.findIndex(x => x.id !== evt.removed.element.id);
            fromList.push(toList[prevItemIndex]);
            toList.splice(prevItemIndex, 1);
        },
        checkQusest(item) {
            if (this.mobile) {
                for (let i = 0; i < this.item.terms.length; i++) {
                    this.item.terms[i].selected = this.answerLists[i][0];
                }
            }

            this.$http.get(`${this.apiUrl}TestTask/GetQuestionTermAnswers?id=${item.id}`)
            .then((res) => {
                // console.log(item.terms);

                let success = [];
                for (let i = 0; i < res.data.length; i++) {
                    for (let j = 0; j < item.terms.length; j++) {
                        if(res.data[i].testQuestionTermId === item.terms[j].id) {
                            if(item.terms[j].selected.id == res.data[i].id) {
                                // console.log('1');
                                success.push(true);
                                item.terms[j].correct = true;
                            } else {
                                // console.log('2');
                                success.push(false);
                                item.terms[j].correct = false;
                                break;
                            }
                        }
                    }
                }

                // console.log(success);

                if(success.indexOf(false) !== -1) {
                    this.randomGenerate('wrongAnswer').then((res) => {
                        this.text = res;
                    })
                    this.flag = true;
                    this.flagError = true;
                    this.flagSuccess = false;
                    // this.text = 'Жаль, вы были близки к успеху...';
                } else {
                    this.randomGenerate('correctlyAnswered').then((res) => {
                        this.text = res;
                    })
                    this.$emit('addPercentageOfPassing');
                    this.flag = true;
                    this.flagError = false;
                    this.flagSuccess = true;
                    // this.text = 'Все верно, продолжайте в том же духе...';
                    
                    party.confetti(this.$refs.answerWrapper, {
                        count: party.variation.range(100, 150),
                        size: party.variation.range(0.6, 1.4),
                    });
                }

                this.$emit('save', {item: this.item}, 2);
                this.viewBtnNext = true;
            })

            // this.$emit('scroll')
        }
    },
    created() {
        for (let i = 0; i < this.item.terms.length; i++) {
            this.$set(this.item.terms[i], 'list', this.item.termAnswers);
            this.$set(this.item.terms[i], 'listFreeze', this.item.termAnswers);
            this.$set(this.item.terms[i], 'selected', {});
        }

        this.mobile = window.document.documentElement.clientWidth <= 960;

        if (this.mobile) {
            this.item.termAnswers.forEach(x => {
                this.answerLists.push([x]);
            });

            this.viewBtnAll = true;
        }
    }
}
</script>

<style scoped>
.btn-block {
    width: 100%;
    margin-top: 25px;
}
.block-text-information {
    width: 100%;
}
.error-text {
    color: #ed4040;
}
.success-text {
    color: #4caf50;
}
.question-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.question {
    margin: 8px 0 20px;
    font-size: 20px;
    line-height: 28px;
    width: 100%;
    text-align: left;
}
.answer-wrapper {
    display: flex;
    flex-direction: column;
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(230, 230, 230);
    border-radius: 8px;
    font-family: "Proxima Nova", sans-serif;
    width: 100%;
}
.answer {
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 0px;
    border-bottom: 1px solid rgb(230, 230, 230);
    padding: 10px 10px 10px 12px;
    color: rgb(0, 0, 0);
    position: relative;
}
.answer:first-child {
    border-radius: 8px 8px 0px 0px;
}
.answer:last-child {
    border-radius: 0px 0px 8px 8px;
    border-bottom: none;
}

.successAnswer::before {
    position: absolute;
    content: "";
    display: block;
    top: 0px;
    left: 3px;
    width: 10px;
    bottom: 0px;
    box-shadow: rgb(78, 180, 84) -4px 0px;
}
.successText {
    color: #4caf50;
}
.errorAnswer::before {
    position: absolute;
    content: "";
    display: block;
    top: 0px;
    left: 3px;
    width: 10px;
    bottom: 0px;
    box-shadow: rgb(237, 64, 64) -4px 0px;
}
.border-top-left-radius-7::before {
    border-top-left-radius: 7px;
}
.border-bottom-left-radius-7::before {
    border-bottom-left-radius: 7px;
}

@media screen and (max-width: 960px) {
    .question {
        margin-top: 0;
    }
    .col-term {
        padding-bottom: 0;
    }
    .list-group {
        display: flex;
        flex-direction: column;
    }
    .list-group-item {
        position: relative;
        display: block;
        padding: .75rem 1.25rem;
        background-color: #fff;
        border: 1px solid rgba(0,0,0,.125);
        cursor: move;
    }
    .list-group-item:first-child {
        border-top-left-radius: .25rem;
        border-top-right-radius: .25rem;
    }
}
</style>